import React from 'react';

const Jobs: React.FC = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-pakistan-green">
          Job Opportunities
        </h1>
        <div className="bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-2xl font-bold mb-4">Available Positions</h3>
          <div className="space-y-4">
            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="font-bold">Manufacturing Supervisor - Karachi</h4>
              <p className="text-gray-600">Full-time • Experience: 2+ years • Salary: PKR 45,000-60,000</p>
            </div>
            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="font-bold">Community Health Worker - Lahore</h4>
              <p className="text-gray-600">Part-time • Experience: Entry Level • Salary: PKR 25,000-35,000</p>
            </div>
            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="font-bold">Education Coordinator - Islamabad</h4>
              <p className="text-gray-600">Full-time • Experience: 3+ years • Salary: PKR 50,000-70,000</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobs;
